export default __webpack_public_path__ + "static/media/budget-overview.ceb6923b.png";